import client from "./client";
import {
  GetSurveyResult,
  SurveyType,
  Answer,
  MacroProduct,
  Product,
  Attractor,
  ProductMarketMatrix,
  InitiativeStrategyMatrix,
  SurveyActionType,
  ValidationIniziativeMatrix,
  ProductDetails,
  OperationPlansSentElement,
} from "@/interfaces";

export const getSurvey = (type: SurveyType) => client.get<GetSurveyResult>(`survey/${type}`);

export const getSurveyByID = (type: SurveyType, id: string, action: string | null) =>
  client.get<GetSurveyResult>(`survey/${type}/${id}${action ? `/${action}` : ""}`);

export const newSurvey = (type: SurveyType, answers: Answer[]) =>
  client.post<GetSurveyResult>(`survey/${type}`, { answers });

export const updateSurvey = (type: SurveyType, id: string, answers: Answer[]) =>
  client.put<GetSurveyResult>(`survey/${type}/${id}`, { answers });

export const updateNewSurvey = (type: SurveyType, id: string, answers: Answer[], actionType: SurveyActionType) =>
  client.post<GetSurveyResult>(`survey/${type}/${id}/${actionType}`, { answers });

export const updateNewSurveyPut = (type: SurveyType, id: string, answers: Answer[], actionType: SurveyActionType) =>
  client.put<GetSurveyResult>(`survey/${type}/${id}/${actionType}`, { answers });

export const getMacroProducts = () => client.get<MacroProduct[]>("macroproducts");

export const deleteMacroProduct = (id: number) => client.delete<any>(`macroproducts/${id}`);

export const updateMacroProduct = (newValues: any, id: number) => client.put<any>(`macroproducts/${id}`, newValues);

export const getProducts = () => client.get<Product[]>("products");

export const deleteProduct = (id: number) => client.delete<any>(`products/${id}`);

export const getAttractors = () => client.get<Attractor[]>("attractions");

export const deleteAttractor = (id: number) => client.delete<any>(`attractions/${id}`);

export const getAttractionStrategies = () => client.get<Product[]>("strategy/attractions");

export const deleteAttractionStrategies = (id: number) => client.delete<any>(`strategy/attractions/${id}`);

export const getAttractionAccessibility = () => client.get<Product[]>("strategy/accessibility");

export const deleteAttractionAccessibility = (id: number) => client.delete<any>(`strategy/accessibility/${id}`);

export const getInitiativePDF = (id: number) => client.download<Blob>(`initiative/pdf/${id}`);

export const getInitiativeAccessibility = (year: number) => client.get<Product[]>(`initiative/accessibility/${year}`);

export const deleteInitiativeAccessibility = (id: number) => client.delete<any>(`initiative/accessibility/${id}`);

export const getInfopointHospitality = () => client.get<Product[]>("infopoints");

export const deleteInfopointHospitality = (id: number) => client.delete<any>(`infopoints/${id}`);

export const getInitiativeHospitality = (year: number) => client.get<Product[]>(`initiative/hospitality/${year}`);

export const deleteInitiativeHospitality = (id: number) => client.delete<any>(`initiative/hospitality/${id}`);

export const getStrategyHospitality = () => client.get<Product[]>("strategy/hospitality");

export const deleteStrategyHospitality = (id: number) => client.delete<any>(`strategy/hospitality/${id}`);

export const getAttractionInitiative = (year: number) => client.get<Product[]>(`initiative/attractions/${year}`);

export const deleteAttractionInitiative = (id: number) => client.delete<any>(`initiative/attractions/${id}`);

export const getMarkets = () => client.get<Attractor[]>("markets");

export const deleteMarket = (id: number) => client.delete<any>(`markets/${id}`);

export const getAnalysisAttractions = () => client.get<Product[]>("analysis/attractions");

export const deleteAnalysisAttractions = (id: number) => client.delete<any>(`analysis/attractions/${id}`);

export const getBrands = () => client.get<Product[]>("brands");

export const deleteBrand = (id: number) => client.delete<Product[]>(`brands/${id}`);

export const getChannels = () => client.get<Product[]>("analysis/positionings");

export const deleteChannel = (id: number) => client.delete<Product[]>(`analysis/positionings/${id}`);

export const getStrategiesAwareness = () => client.get<Product[]>("strategy/awareness");

export const deleteStrategyAwareness = (id: number) => client.delete<Product[]>(`strategy/awareness/${id}`);

export const getStrategiesVisibility = () => client.get<Product[]>("strategy/visibility");

export const deleteStrategyVisibility = (id: number) => client.delete<Product[]>(`strategy/visibility/${id}`);

export const getInitiativeVisibility = (year: number) => client.get<Product[]>(`initiative/visibility/${year}`);

export const deleteInitiativeVisibility = (id: number) => client.delete<Product[]>(`initiative/visibility/${id}`);

export const getInitiativeAwareness = (year: number) => client.get<Product[]>(`initiative/awareness/${year}`);

export const deleteInitiativeAwareness = (id: number) => client.delete<Product[]>(`initiative/awareness/${id}`);

export const getAnalysisPlanning = () => client.get<Product[]>("analysis/plannings");

export const getAnalysisHistoricalCentres = () => client.get<Product[]>("analysis/oldtowns");

export const getProductsMarketsMatrix = () => client.get<ProductMarketMatrix[]>("products/marketsMatrix");

export const getInitiativeStrategyMatrix = () => client.get<InitiativeStrategyMatrix[]>("initiative/strategyMatrix");

export const createProject = (body: any) => client.downloadPost<Blob>("initiative/createProject", body);

export const getOperationPlansSent = (year?: number) => client.get<OperationPlansSentElement[]>(`dmps${year ? `/${year}` : ""}`);

export const getValidationIniziative = (year: number) =>
  client.get<ValidationIniziativeMatrix[]>(`initiative/validated/${year}`);

export const updateValidationIniziative = (id: number, content: any) =>
  client.put<any>(`initiative/validated/${id}`, { ...content });

export const submitSurveys = () => client.get<any>("dmp/submit");

export const getDmpPreview = () => client.get<any>("dmp/preview");

export const getProductDetails = (id: number) => client.get<ProductDetails[]>(`products/details/${id}`);
